import * as images from "@/components/images/Images";
import { ServicesEnsureComplianceData } from "./types";
import { ROUTES } from "@/constants";

const contentNotarized: ServicesEnsureComplianceData = {
  title: "Ensure your notary certified translations meet requirements",
  description:
    "Languex offers fast, accurate notarized translations with official notary verification. Typically delivered within 24 hours, notarized translations are essential for documents like immigration paperwork, passport applications, and legal documents. Get notarized services for an additional $19.95 by selecting the add-on during checkout.",
  imageUrl: images.servicesNotarizedEnsureCompliance,
  imageDimensions: {
    width: 990,
    height: 793,
  },
  primaryButton: {
    href: "#",
    label: "Learn more",
  },
  secondaryButton: null,
} as const;

const contentUrgent: ServicesEnsureComplianceData = {
  title: "Fast translation services without sacrificing quality",
  description:
    "Our standard delivery on most projects is 24-hours, however, we can turn around urgent standard and certified translations 50% faster for just $10 additional cost at checkout. Our expedited translations are delivered within 12 to 24 hours or sooner.",
  imageUrl: images.servicesUrgentEnsureCompliance,
  imageDimensions: {
    width: 990,
    height: 793,
  },
  primaryButton: null,
  secondaryButton: {
    href: ROUTES.startOrder,
    label: "Start order",
  },
} as const;

export const servicesEnsureComplianceMap = {
  notarized: contentNotarized,
  urgent: contentUrgent,
};
